export default __webpack_public_path__ + "static/img1@2x-acc182f413f6743a887ae7ed636a5b00.jpg";